<template>
  <div class="siteFooter footerOffWhite safedigFooter safedigFooterBlock">
    <div class="safedigCustomFooter">
      <div>
        <img
          src="../../assets/safe-dig/safedig_logo_grayscale-01.png"
          class="safedigindiana811Logo"
          alt="Safe Dig Indiana"
        />
      </div>
      <p class="copyright">
        {{ $t('footer.copyright', { year }) }}<br>
        {{ $t('footer.allRightsReserved') }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SafeDigFooter',
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>

<style scoped>
.siteFooter {
  width: 100%;
  flex-shrink: 0;
}

.footerOffWhite {
  background: #e8e8e8;
}

.safedigFooter {
  background-color: #e8e8e8;
}

.safedigCustomFooter {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2.5rem 2rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
}

.safedigindiana811Logo {
  display: block;
  height: 60px;
  max-height: 60px;
  width: auto;
}

.copyright {
  margin: 0;
  color: #6b6b6b;
  font-size: 0.85rem;
  line-height: 1.5;
  text-align: center;
}
</style>
